// app/javascript/controllers/horizontal_scroll_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftButton", "rightButton"]

  connect() {
    this.updateButtonVisibility()
    this.containerTarget.addEventListener("scroll", () => this.updateButtonVisibility())

    // Also update on window resize
    window.addEventListener("resize", () => this.updateButtonVisibility())
  }

  disconnect() {
    window.removeEventListener("resize", () => this.updateButtonVisibility())
  }

  scrollLeft() {
    const scrollAmount = this.containerTarget.clientWidth * 0.75
    this.containerTarget.scrollBy({ left: -scrollAmount, behavior: "smooth" })
  }

  scrollRight() {
    const scrollAmount = this.containerTarget.clientWidth * 0.75
    this.containerTarget.scrollBy({ left: scrollAmount, behavior: "smooth" })
  }

  updateButtonVisibility() {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget
    const isAtStart = scrollLeft <= 0
    const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1

    // Show/hide left button
    if (this.hasLeftButtonTarget) {
      this.leftButtonTarget.classList.toggle("opacity-0", isAtStart)
      this.leftButtonTarget.classList.toggle("pointer-events-none", isAtStart)
      this.leftButtonTarget.classList.toggle("opacity-100", !isAtStart)
      this.leftButtonTarget.classList.toggle("pointer-events-auto", !isAtStart)
    }

    // Show/hide right button
    if (this.hasRightButtonTarget) {
      this.rightButtonTarget.classList.toggle("opacity-0", isAtEnd)
      this.rightButtonTarget.classList.toggle("pointer-events-none", isAtEnd)
      this.rightButtonTarget.classList.toggle("opacity-100", !isAtEnd)
      this.rightButtonTarget.classList.toggle("pointer-events-auto", !isAtEnd)
    }
  }
}
